"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RetrievalParams {
    constructor(params) {
        this._getAll = params ? params.getAll ? true : false : false;
        this._items = params ? params.items ? params.items : 25 : 25;
        this._offset = this._getAll ? 0 : (params ? params.offset ? params.offset : 0 : 0);
        this._filters = params.filters ? params.filters : [];
        this._sortBy = params.sortBy ? params.sortBy : null;
    }
    get filters() {
        return this._filters;
    }
    get items() {
        return this._items;
    }
    get offset() {
        return this._offset;
    }
    get getAll() {
        return this._getAll;
    }
    get sortBy() {
        return this._sortBy;
    }
}
exports.default = RetrievalParams;
//# sourceMappingURL=retrieval-params.js.map